// Slug oluşturma utility fonksiyonları

export const createSlug = (text: string): string => {
   if (!text) return '';
  
  return text
    .toString()
    .toLowerCase()
    .trim()
    // Türkçe karakterleri İngilizce karşılıkları ile değiştir
    .replace(/ğ/gi, 'g')
    .replace(/ü/gi, 'u')
    .replace(/ş/gi, 's')
    .replace(/ı/gi, 'i')
    .replace(/ö/gi, 'o')
    .replace(/ç/gi, 'c')
    // Boşlukları tire ile değiştir
    .replace(/\s+/g, '-')
    // Özel karakterleri kaldır (sadece harf, sayı ve tire kalsın)
    .replace(/[^a-z0-9-]/g, '')
    // Çoklu tireleri tek tire yap
    .replace(/-+/g, '-')
    // Başında ve sonunda tire varsa kaldır
    .replace(/^-+|-+$/g, '');
};

// Debug için test fonksiyonu
export const testSlug = (input: string) => {
  const result = createSlug(input);
  return result;
};

// Slug'ın unique olup olmadığını kontrol etmek için
export const generateUniqueSlug = async (
  baseText: string, 
  checkFunction: (slug: string) => Promise<boolean>,
  excludeId?: string
): Promise<string> => {
  let slug = createSlug(baseText);
  let counter = 1;
  let originalSlug = slug;
  
  while (await checkFunction(slug)) {
    slug = `${originalSlug}-${counter}`;
    counter++;
  }
  
  return slug;
};